const Footer = () => {
    return (
        <footer className="bg-dark text-white/40 border-t border-white/5">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">

                    {/* Brand */}
                    <div className="col-span-1 md:col-span-1">
                        <div className="flex items-center gap-3 mb-4">
                            <img src="/logo_rd.png" alt="Next Pro 360" className="w-9 h-9 rounded-xl object-contain" />
                            <span className="font-black text-xl tracking-tight text-white">Next <span className="text-brand-400">Pro 360</span></span>
                        </div>
                        <p className="text-sm text-white/35 mb-6 leading-relaxed">
                            El sistema operativo de tu negocio. Inventario, citas, facturacion y clientes — todo conectado, nada perdido.
                        </p>
                        <div className="flex gap-3">
                            <a href="#" className="w-9 h-9 rounded-full glass flex items-center justify-center hover:bg-brand-600/40 hover:text-white transition-all text-white/40">
                                <i data-lucide="facebook" className="w-4 h-4"></i>
                            </a>
                            <a href="#" className="w-9 h-9 rounded-full glass flex items-center justify-center hover:bg-brand-600/40 hover:text-white transition-all text-white/40">
                                <i data-lucide="instagram" className="w-4 h-4"></i>
                            </a>
                            <a href="#" className="w-9 h-9 rounded-full glass flex items-center justify-center hover:bg-brand-600/40 hover:text-white transition-all text-white/40">
                                <i data-lucide="twitter" className="w-4 h-4"></i>
                            </a>
                        </div>
                    </div>

                    {/* Links */}
                    <div>
                        <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Navegacion</h4>
                        <ul className="space-y-2.5 text-sm">
                            <li><a href="#inicio"    className="hover:text-brand-400 transition-colors">Inicio</a></li>
                            <li><a href="#servicios" className="hover:text-brand-400 transition-colors">Funciones</a></li>
                            <li><a href="#nosotros"  className="hover:text-brand-400 transition-colors">Beneficios</a></li>
                            <li><a href="#precios"   className="hover:text-brand-400 transition-colors">Precios</a></li>
                            <li><a href="#contacto"  className="hover:text-brand-400 transition-colors">Registrar Negocio</a></li>
                        </ul>
                    </div>

                    {/* Modulos */}
                    <div>
                        <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Modulos</h4>
                        <ul className="space-y-2.5 text-sm">
                            <li><a href="#servicios" className="hover:text-brand-400 transition-colors">Control de Inventario</a></li>
                            <li><a href="#servicios" className="hover:text-brand-400 transition-colors">IA de Stock</a></li>
                            <li><a href="#servicios" className="hover:text-brand-400 transition-colors">Agendamiento y Citas</a></li>
                            <li><a href="#servicios" className="hover:text-brand-400 transition-colors">Historial del Cliente</a></li>
                            <li><a href="#servicios" className="hover:text-brand-400 transition-colors">Facturacion Rapida</a></li>
                            <li><a href="#servicios" className="hover:text-brand-400 transition-colors">CRM de Clientes</a></li>
                            <li><a href="#servicios" className="hover:text-brand-400 transition-colors">Reportes Financieros</a></li>
                        </ul>
                    </div>

                    {/* CTA */}
                    <div>
                        <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Empieza hoy</h4>
                        <p className="text-sm text-white/35 mb-5 leading-relaxed">Registra tu negocio y recibe tu Landing Page propia desde el dia uno. Para cualquier nicho.</p>
                        <a href="#contacto"
                            className="inline-block text-white px-5 py-3 rounded-xl font-bold text-sm w-full text-center hover:opacity-90 transition-all"
                            style={{ background: 'linear-gradient(135deg, #7c3aed, #8b5cf6)' }}>
                            Registrar mi Negocio
                        </a>
                        <div className="mt-4 flex flex-wrap gap-2">
                            {['Talleres', 'Salones', 'Clinicas', 'Gimnasios', 'Veterinarias'].map(n => (
                                <span key={n} className="glass text-white/35 text-xs px-2.5 py-1 rounded-full">{n}</span>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-3 text-sm text-white/20">
                    <p>© 2026 Next Pro 360 — Desarrollo RD. Todos los derechos reservados.</p>
                    <div className="flex gap-5">
                        <a href="#" className="hover:text-white/50 transition-colors">Terminos y Condiciones</a>
                        <a href="#" className="hover:text-white/50 transition-colors">Politica de Privacidad</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
